import { AudioMix } from "./audio-mix";
import { CompressFormat } from "./compress-format";
import { JobNotification } from "./job-notification";
import { TranskodeWrapper } from "./transkode-wrapper";

export enum WhisperModels {
  Tiny = "Tiny",
  Base = "Base",
  Small = "Small",
  Medium = "Medium",
  Large = "Large",
  Turbo = "Turbo",
}
export enum ImageConvertEngine {
  ImageSharp = "ImageSharp",
  ImageMagick = "ImageMagick",
}

export enum AtmosRendererLogLevel {
  NONE = "NONE",
  FATAL = "FATAL",
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
  DEBUG = "DEBUG",
  TRACE = "TRACE",
}

export enum AtmosRendererOutputFileType {
  MP4 = "MP4",
  WAV = "WAV",
}

export class JobBaseInfos {
  $type?: string | null = null;
  jobStringId: string | null = null;
  jobLongId: number | null = null;
  notification: JobNotification | null = null;
  constructor(init?: Partial<JobBaseInfos>) {
    Object.assign(this, init);
  }
}
export class JobTranscodeByTemplateAmberfin extends JobBaseInfos {
  template: string | null = null;
  conversion?: string | null = null;
}
export class JobLiquidExport extends JobBaseInfos {
  liquidTemplate: string | null = null;
  templateName: string | null = null;
  outputFilePath?: string | null = null;
}
export class JobQcBatonVerifyFile extends JobBaseInfos {
  testPlan: string | null = null;
}
export class JobConvertImage extends JobBaseInfos {
  codec: TranskodeWrapper = TranskodeWrapper.PNG;
  quality: number | null = null;
}
export class JobGenerateAAF extends JobBaseInfos {}
export class JobFileCompress extends JobBaseInfos {
  deleteSource: boolean | null = null;
  compressFormat: CompressFormat | null = null;
  parseResult?: boolean | null = null;
}
export class JobAuthotSpeechToText extends JobBaseInfos {
  humanCheck?: boolean = false;
  creditCheck?: boolean = false;
  analyzeAudioLanguageIfNotFound?: boolean = false;
}
export class JobWhisperSpeechToText extends JobBaseInfos {
  whisperModel: WhisperModels = WhisperModels.Turbo;
}
export class JobAudioWaveformGenerate extends JobBaseInfos {
  zoom?: number | null = null;
  bits?: number | null = null;
}
export class JobArchiveDiva extends JobBaseInfos {
  deleteSource?: boolean = false;
}
export enum FFmpegVersion {
  V6 = "V6",
  V7 = "V7",
  V71 = "V71",
}
export class JobTranscodeUsingFFmpeg extends JobBaseInfos {
  args?: string | null = null;
  exitCodeExpected?: number | null = null;
  timeOut?: number | null = null;
  parseMedia?: boolean = false;
  parseThumbs?: boolean = false;
  parseSceneDetect?: boolean = false;
  version?: FFmpegVersion | null = null;
}
export class JobExecuteCommandAmberfin extends JobBaseInfos {
  exePath?: string | null = null;
  exitCodeExpected?: number | null = null;
  timeOut?: number | null = null;
}
export class JobFileAsperaTransferServerToServerAmberfin extends JobBaseInfos {
  direction?: string | null = null;
  transferRateKbps?: number | null = null;
  overwrite?: boolean = false;
  transferMode?: string | null = null;
  timeoutMin?: number | null = null;
}
export class JobFileAsperaTransferServerToServer extends JobBaseInfos {
  direction?: string | null = null;
  transferRateKbps?: number | null = null;
  overwrite?: boolean = false;
  transferMode?: string | null = null;
  timeoutMin?: number | null = null;
}
export class JobFileCopyAmberfin extends JobBaseInfos {
  deleteSourceOnSuccess?: boolean = false;
  takeCareLinkedFiles?: boolean = false;
}
export class JobFileCopyInternalAsync extends JobBaseInfos {
  deleteSourceOnSuccess?: boolean = false;
  takeCareLinkedFiles?: boolean = false;
}
export class JobConvertSubtitle extends JobBaseInfos {
  format?: string | null = null;
  outputFrameRate?: number | null = null;
  configFilePath?: string | null = null;
  configFileType?: string | null = null;
}

export class JobAudioLanguageDetection extends JobBaseInfos {
  classifierProcessEveryNth?: number | null = null;
  topNthLanguages?: number | null = null;
  whisperModel?: WhisperModels | null = null;
  vadTreshold?: number | null = null;
  vadUseOnnx?: boolean | null = null;
  setAudioChannelsLanguagePostAction: boolean = false;
  setAudioMainLanguagePostAction: boolean = false;
}

export class JobAudioAtmosRenderer extends JobBaseInfos {
  outputAudioMix: AudioMix = AudioMix.Mix_2_0;
  outputFileType: AtmosRendererOutputFileType = AtmosRendererOutputFileType.MP4;
  atmosRendererLogLevel: AtmosRendererLogLevel = AtmosRendererLogLevel.INFO;
}
